import loginIndex from '../views/login/index'
import loginRegister from '../views/login/register'
import registerSuc from '../views/login/registerSuc'
import login from '../views/login/login'
import mologin from '../views/login/mologin'

import moregister from '../views/login/moregister'
import mofindpsdOne from '../views/login/mofindpsdOne'



import sweep from '../views/login/sweep'
import getpass from '../views/login/getpass'
import getpassSuc from '../views/login/getpassSuc'
// 首页
import index from '../views/home/index'
import home from '../views/home/home'
import health from '../views/home/health'
import build from '../views/home/build'
import magazine from '../views/home/magazine'
import meeting from '../views/home/meeting'
// 列表详情页
import Inforlist from '../views/information/Inforlist'
import litelist from '../views/information/litelist'
import litelist2 from '../views/information/litelist2'
import inforDetails from '../views/information/inforDetails'
import litedetails from '../views/information/litedetails'
import specialHome from '../views/information/specialHome'
import specialHome2 from '../views/information/specialHome2'
import specialDetails from '../views/information/specialDetails'
import searchPage from '../views/information/searchPage'
// 企业专题
import enterprise from '../views/enterprise/index'
import qyhome from '../views/enterprise/home'
import enterpriseList from '../views/enterprise/enterpriseList'
import enterpriseList2 from '../views/enterprise/enterpriseList2'
import enterpriseDetail from '../views/enterprise/enterpriseDetail'

// 用户中心
import user from '../views/user/index'
import userInfor from '../views/user/userInfor'
import userData from '../views/user/userData'
import userMyInforShow from '../views/user/userMyInforShow'
import userSubscribe from '../views/user/userSubscribe'
import userSubscribeOpera from '../views/user/userSubscribeOpera'
import userSubscribeMenu from '../views/user/userSubscribeMenu'
import userVip from '../views/user/userVip'
import userMyCourse from '../views/user/userMyCourse'
import userShopping from '../views/user/userShopping'
import userMyOrder from '../views/user/userMyOrder'
import userMyInvoice from '../views/user/userMyInvoice'
import userMyCollection from '../views/user/userMyCollection'
import userExchange from '../views/user/userExchange'
import userMymsg from '../views/user/userMymsg'
// 会议
import meetingIndex from '../views/meeting/index'
import meetingpc from '../views/meeting/meetingpc'
import meetingDetail from '../views/meeting/meetingDetail'
import meetingMobile from '../views/meeting/meetingMobile'
import meetingMobileDetail from '../views/meeting/meetingMobileDetail'
import muduLive from '../views/meeting/muduLive'
import huodeLive from '../views/meeting/huodeLive'
import channelList from '../views/meeting/channelList'


//杂志
import magazineindex from '../views/information/index'

//Loading
import Loading from '@/views/components/Loading/Loading'

const routesList = [
    { path: '/', redirect: '/home' },
    {
        path: '/home',
        name: 'home',
        component: index,
        redirect: '/home',
        meta: { navShow: true, breadcrumbTitle: '首页' },
        children: [
            {
                path: '',
                name: 'home',
                component: home,
                meta: {
                    navShow: true,
                    activeNum: 0,
                    title: '全科医学-首页',
                },
            },
            {
                path: 'Inforlist',
                name: 'Inforlist',
                component: Inforlist,
                meta: {
                    navShow: true,
                    title: '中文资讯列表页',
                    breadcrumbTitle: '资讯列表',
                },
            },

            {
                path: 'inforDetails',
                name: 'inforDetails',
                component: inforDetails,
                meta: {
                    navShow: true,
                    title: '中文资讯详情',
                    breadcrumbTitle: '资讯详情',
                },
            },
            {
                path: 'specialRecomme',
                name: 'specialRecomme',
                component: specialHome,
                meta: {
                    navShow: true,
                    title: '专题',
                    breadcrumbTitle: '资讯专题首页',
                },
            },
            {
                path: 'specialHome2',
                name: 'specialHome2',
                component: specialHome2,
                meta: {
                    navShow: true,
                    title: '资讯专题首页2',
                    breadcrumbTitle: '资讯专题首页2',
                },
            },
            {
                path: 'specialDetails',
                name: 'specialDetails',
                component: specialDetails,
                meta: {
                    navShow: true,
                    title: '资讯专题详情页',
                    breadcrumbTitle: '资讯专题详情',
                },
            },
            {
                path: 'searchPage',
                name: 'searchPage',
                component: searchPage,
                meta: {
                    navShow: true,
                    title: '搜索页面',
                    breadcrumbTitle: '搜索',
                },
            },
        ],
    },
    {
        path: '/loginIndex',
        name: 'loginIndex',
        component: loginIndex,
        children: [
            {
                path: 'loginRegister',
                name: 'loginRegister',
                component: loginRegister,
                meta: { navShow: false, title: '全科医学-注册' },
            },
            {
                path: 'registerSuc',
                name: 'registerSuc',
                component: registerSuc,
            },
            {
                path: 'login',
                name: 'login',
                component: login,
                meta: { navShow: false, title: '全科医学-登录' },
            },
            {
                path: 'sweep',
                name: 'sweep',
                component: sweep,
                meta: { navShow: false, title: '全科医学-微信扫码登录' },
            },
            {
                path: 'getpass',
                name: 'getpass',
                component: getpass,
                meta: { navShow: false, title: '全科医学-找回密码' },
            },
            { path: 'getpassSuc', name: 'getpassSuc', component: getpassSuc },
        ],
    },
    {
        path: '/mologin',
        name: 'mologin',
        component: mologin,
        meta: { navShow: false, title: '全科医学-登录' },
    },
    {
        path: '/moregister',
        name: 'moregister',
        component: moregister,
        meta: { navShow: false, title: '全科医学-注册' },
    },
    {
        path: '/mofindpsdOne',
        name: 'mofindpsdOne',
        component: mofindpsdOne,
        meta: { navShow: false, title: '全科医学-找回密码' },
    },
    {
        path: '/grassheal',
        name: 'health',
        component: health,
        meta: { navShow: true, activeNum: 1, title: '全科医学-基层卫生' },
    },
    {
        path: '/magazine',
        name: 'magazine',
        component: magazineindex,
        redirect: '/magazine',
        meta: {
            navShow: true,
            activeNum: 2,
            breadcrumbTitle: '杂志专区',
            title: '全科医学-杂志专区',
        },
        children: [
            {
                path: '/',
                name: 'magazine',
                component: magazine,
                meta: {
                    activeNum: 2,
                    navShow: true,
                    title: '期刊浏览',
                    breadcrumbTitle: '杂志专区',
                },
            },
            {
                path: 'magazinesectionlist',
                name: 'magazinesectionlist',
                component: litelist,
                meta: {
                    activeNum: 2,
                    navShow: true,
                    title: '期刊浏览',
                    breadcrumbTitle: '期刊浏览',
                },
            },
            {
                path: 'magazinejournal',
                name: 'magazinejournal',
                component: litelist2,
                meta: {
                    navShow: true,
                    activeNum: 2,
                    title: '全科医学-杂志专区',
                    breadcrumbTitle: '期刊浏览',
                },
            },
            {
                path: 'magazinejournal/magazinejournaldetail',
                name: 'magazinejournaldetail',
                component: litedetails,
                meta: {
                    navShow: true,
                    activeNum: 2,
                    title: '中文文献详情',
                    breadcrumbTitle: '文献详情',
                },
            },
        ],
    },
    {
        path: '/disciconstruc',
        name: 'build',
        component: build,
        meta: { navShow: true, activeNum: 5, title: '全科医学-学科建设' },
    },
    {
        path: '/meeting',
        name: 'meeting',
        component: meeting,
        meta: { navShow: true, activeNum: 4, title: '全科医学-学术会议' },
    },

    {
        path: '/enterprise',
        name: 'enterprise',
        component: enterprise,
        redirect: '/enterprise/qyhome',
        meta: { navShow: true, breadcrumbTitle: '企业专题首页' },
        children: [
            {
                path: 'qyhome',
                name: 'qyhome',
                component: qyhome,
                meta: {
                    navShow: false,
                    activeNum: 'qy0',
                    title: '企业专题首页',
                },
            },
            {
                path: 'enterpriseList',
                name: 'enterpriseList',
                component: enterpriseList,
                meta: {
                    activeNum: 'qy1',
                    title: '企业专题列表页1',
                    breadcrumbTitle: '企业专题列表页1',
                },
            },
            {
                path: 'enterpriseList2',
                name: 'enterpriseList2',
                component: enterpriseList2,
                meta: {
                    activeNum: 'qy2',
                    title: '企业专题列表页2',
                    breadcrumbTitle: '企业专题列表页2',
                },
            },
            {
                path: 'enterpriseDetail',
                name: 'enterpriseDetail',
                component: enterpriseDetail,
                meta: {
                    activeNum: 'qy3',
                    title: '企业专题详情页',
                    breadcrumbTitle: '企业专题详情页',
                },
            },
        ],
    },
    {
        path: '/user',
        name: 'user',
        component: user,
        redirect: '/user/userInfor',
        children: [
            {
                path: 'userInfor',
                name: 'userInfor',
                component: userInfor,
                meta: { navShow: true, activeNum: '', title: '个人中心' },
            },
            {
                path: 'userData',
                name: 'userData',
                component: userData,
                meta: { navShow: true, activeNum: '', title: '个人资料修改' },
            },
            {
                path: 'userMyInforShow',
                name: 'userMyInforShow',
                component: userMyInforShow,
                meta: { navShow: true, activeNum: '', title: '个人资料展示' },
            },
            {
                path: 'userSubscribe',
                name: 'userSubscribe',
                component: userSubscribe,
                meta: { navShow: true, activeNum: '', title: '开启订阅' },
            },
            {
                path: 'userSubscribeOpera',
                name: 'userSubscribeOpera',
                component: userSubscribeOpera,
                meta: { navShow: true, activeNum: '', title: '订阅操作' },
            },
            {
                path: 'userSubscribeMenu',
                name: 'userSubscribeMenu',
                component: userSubscribeMenu,
                meta: { navShow: true, activeNum: '', title: '我的订阅' },
            },
            {
                path: 'userVip',
                name: 'userVip',
                component: userVip,
                meta: { navShow: true, activeNum: '', title: 'VIP中心' },
            },
            {
                path: 'userMyCourse',
                name: 'userMyCourse',
                component: userMyCourse,
                meta: { navShow: true, activeNum: '', title: '我的课程' },
            },
            {
                path: 'userShopping',
                name: 'userShopping',
                component: userShopping,
                meta: { navShow: true, activeNum: '', title: '我的购物车' },
            },
            {
                path: 'userMyOrder',
                name: 'userMyOrder',
                component: userMyOrder,
                meta: { navShow: true, activeNum: '', title: '我的订单' },
            },
            {
                path: 'userMyInvoice',
                name: 'userMyInvoice',
                component: userMyInvoice,
                meta: { navShow: true, activeNum: '', title: '我的发票' },
            },
            {
                path: 'userMyCollection',
                name: 'userMyCollection',
                component: userMyCollection,
                meta: { activeNum: '', title: '我的收藏' },
            },
            {
                path: 'userExchange',
                name: 'userExchange',
                component: userExchange,
                meta: { activeNum: '', title: '兑换入口' },
            },
            {
                path: 'userMymsg',
                name: 'userMymsg',
                component: userMymsg,
                meta: { activeNum: '', title: '我的消息' },
            }
        ],
    },
    {
        path: '/meetingIndex',
        name: 'meetingIndex',
        component: meetingIndex,
        redirect: '/meetingIndex/meetingpc',
        meta: { navShow: false, breadcrumbTitle: '首页' },
        children: [
            {
                path: 'meetingpc',
                name: 'meetingpc',
                component: meetingpc,
                meta: { navShow: false, title: '会议PC端首页' },
            },
            {
                path: 'meetingDetail',
                name: 'meetingDetail',
                component: meetingDetail,
                meta: {
                    navShow: false,
                    title: '会议PC端详情页',
                    breadcrumbTitle: '详情',
                },
            },
        ],
    },
    {
        path: '/meetingMobile',
        name: 'meetingMobile',
        component: meetingMobile,
        meta: { navShow: false, title: '会议移动端首页' },
    },
    {
        path: '/muduLive',
        name: 'muduLive',
        component: muduLive,
        meta: { navShow: false, title: '全科医学网' },
    },
    {
        path: '/huodeLive',
        name: 'huodeLive',
        component: huodeLive,
        meta: { navShow: false, title: '全科医学网' },
    },
    {
        path: '/channelList',
        name: 'channelList',
        component: channelList,
        meta: { navShow: false, title: '直播列表' },
    },
    {
        path: '/meetingMobileDetail',
        name: 'meetingMobileDetail',
        component: meetingMobileDetail,
        meta: { navShow: false, title: '会议移动端详情页' },
    },
    {
        path: '/Loading',
        name: 'Loading',
        component: Loading,
        meta: { navShow: false },
    },
]

export default routesList
